<div
    class="card-container w-64 rounded-3xl bg-white mx-2 my-4 overflow-hidden duration-500 shadow-3xl hover:-translate-y-1 hover:shadow-3xl-up">
    <a routerLink="/teacher/{{name}}"
        class="!text-zinc-900">
        <div class="bg-slate-800 h-32">
            <div class="image-container bg-white w-36 h-36 rounded-full p-2 translate-x-14 translate-y-10">
                <img class="w-32 h-32 rounded-full"
                    alt="Teacher image"
                    [src]="backendUrl + teacherImageSource" />
            </div>
        </div>
        <div class="lower-container bg-white p-4 text-center">
            <div>
                <h2 class="text-xl mt-10 font-bold">{{displayName}}</h2>
                <h3 class="font-bold opacity-80">{{title}}</h3>
            </div>
            <div>
                <button mat-button
                    color="primary">View Profile</button>
            </div>
        </div>
    </a>
</div>